import { api } from '../api'
import { useAuth } from '../AuthContext'
import { getCached, setCached, useCachedFetch } from '../lib/swr'

// Dossier exposant (ADR-071) — charge UNE SEULE FOIS puis partage par tous
// ses lecteurs : bulle RINA de chaque page, Mon compte, accueil producteur,
// confirmation de stand, page du dossier.
//
// useCachedFetch revalide a CHAQUE montage ; la bulle RINA se remonte a chaque
// page — sans garde, chaque navigation relancerait la requete. On ne retourne
// donc au serveur qu'apres FRAICHEUR_MS ; entre-temps chaque ecriture (PATCH,
// envoi d'une piece) remplace l'etat par celui que l'API renvoie.
//
// La cle porte l'id du compte : le cache memoire survit a une deconnexion, le
// dossier d'une personne ne doit jamais s'afficher a la suivante.
//
// Contrat : data = etat calcule par l'API | null (pas d'organisation) | undefined
// (pas encore charge).
const FRAICHEUR_MS = 5 * 60 * 1000
const cle = (userId) => `/producer/dossier-exposant:${userId}`

const lueA = new Map() // cle -> horodatage de la derniere lecture serveur
const enVol = new Map() // cle -> promesse en cours

function charger(k) {
  const cache = getCached(k)
  if (cache !== undefined && Date.now() - (lueA.get(k) || 0) < FRAICHEUR_MS) return Promise.resolve(cache)
  if (!enVol.has(k)) {
    enVol.set(k, api.producer.getDossierExposant()
      .catch((e) => {
        // 403/404 : ce compte n'a pas d'organisation — pas de dossier, pas de rappel.
        if (/Erreur 40[34]/.test(e.message)) return null
        throw e
      })
      .then((d) => { lueA.set(k, Date.now()); return d })
      .finally(() => enVol.delete(k)))
  }
  return enVol.get(k)
}

/** Remplace l'etat partage par celui que l'API vient de renvoyer. */
export function useMajDossierExposant() {
  const { user } = useAuth()
  return (etat) => {
    if (!user?.id) return
    lueA.set(cle(user.id), Date.now())
    setCached(cle(user.id), etat)
  }
}

export default function useDossierExposant({ enabled = true } = {}) {
  const { user, isAuthenticated } = useAuth()
  const k = cle(user?.id)
  const { data } = useCachedFetch(k, () => charger(k), { enabled: enabled && isAuthenticated && !!user?.id })
  return data
}

// Ecritures — passent par ce module (seul lecteur de l'API pour le dossier) :
// chacune renvoie l'etat recalcule par le serveur, a poser via useMajDossierExposant.
export const enregistrerDossier = (data) => api.producer.majDossierExposant(data)
export const envoyerPieceDossier = (code, fichier, dateValidite) =>
  api.producer.envoyerPieceDossier(code, fichier, dateValidite)
export const relireDossier = () => api.producer.getDossierExposant()
// Registre public des entreprises (S74) : retrouver son SIRET par le nom.
export const chercherEntreprise = (q) => api.producer.chercherEntreprise(q)
